import { securedAxiosInstance } from "../axios";

class PlanSaleService {
  sendConfirmationEmail(planSaleId) {
    return securedAxiosInstance.post(`/plan_sales/${planSaleId}/send_confirmation`);
  }
}

export default new PlanSaleService();
